<template>
	<div :class="layoutContainerClass" @click="onDocumentClick">
		<router-view v-if="isLargeScreen" />
        <template v-else>
            <AppBreadcrumb :menuMode="menuMode" v-model:searchActive="searchActive" v-model:searchClick="searchClick"
                           :activeInlineProfile="activeInlineProfile"
                           @menubutton-click="onMenuButtonClick"  @rightmenu-button-click="onRightMenuButtonClick"
                           @change-inlinemenu="onChangeActiveInlineMenu"/>
		<div class="layout-main">
			<AppMenu :model="menu" :menuMode="menuMode" :colorScheme="colorScheme" :menuActive="menuActive"
				:sidebarActive="sidebarActive" :sidebarStatic="sidebarStatic" :pinActive="pinActive"
				:activeInlineProfile="activeInlineProfile" @sidebar-mouse-over="onSidebarMouseOver"
				@sidebar-mouse-leave="onSidebarMouseLeave" @toggle-menu="onToggleMenu"
				@change-inlinemenu="onChangeActiveInlineMenu" @menu-click="onMenuClick" @menuitem-click="onMenuItemClick"
				@root-menuitem-click="onRootMenuItemClick" />
            <AppTopBar :items="menu" :menuMode="menuMode" :colorScheme="colorScheme" :menuActive="menuActive"
                       :topbarMenuActive="topbarMenuActive" :activeInlineProfile="activeInlineProfile"
                       @topbar-item-click="onTopbarItemClick" @menubutton-click="onMenuButtonClick"
                       @sidebar-mouse-over="onSidebarMouseOver" @sidebar-mouse-leave="onSidebarMouseLeave"
                       @toggle-menu="onToggleMenu" @change-inlinemenu="onChangeActiveInlineMenu" @menu-click="onMenuClick"
                       @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick" />


			<div class="layout-main-content" style="padding:10px 30px">
				<ConfirmDialog></ConfirmDialog>
				<Toast position="top-center"></Toast>
				<router-view />
			</div>

			<AppFooter :colorScheme="colorScheme" />
		</div>
		<AppRightMenu :rightMenuActive="rightMenuActive" @rightmenu-click="onRightMenuClick"
			@rightmenu-active="onChangeRightMenuActive" />

		<LoginInvialid v-show="loginInvialid">

		</LoginInvialid>
        </template>
	</div>
</template>

<script>
import AppTopBar from './AppTopbar.vue';
import AppMenu from './AppMenu.vue';
import AppRightMenu from './AppRightMenu.vue';
import AppFooter from './AppFooter.vue';
import AppBreadcrumb from './AppBreadcrumb.vue';
import AppConfig from './AppConfig.vue';
import EventBus from './event-bus';


export default {
	emits: ['layout-mode-change', 'menu-theme', 'layoutModeChange', 'sidebar-mouse-over', 'sidebar-mouse-leave', 'change-color-scheme', 'change-component-theme', 'change-menu-theme', 'change-inlinemenu'],
	props: {
		colorScheme: String,
		topbarTheme: String,
		theme: String,
		componentTheme: String

	},
	data() {
		return {
			isLargeScreen: location.href.includes('/largeScreen/') || location.href.includes('/alone/'),
			styleInfo: { height: "98vh", width: "100%" },
			config: null,
			spreadOptions: {
				sheetCount: 2,
			},
			designer: null,
			search: false,
			searchClick: false,
			searchActive: false,
			menuMode: 'sidebar',
			menuActive: false,
			activeInlineProfile: false,
			inlineMenuClick: false,
			overlayMenuActive: false,
			topbarMenuActive: false,
			topbarItemClick: false,
			sidebarActive: false,
			sidebarStatic: false,
			pinActive: false,
			staticMenuDesktopInactive: false,
			staticMenuMobileActive: false,
			rightMenuClick: false,
			rightMenuActive: false,
			configActive: false,
			configClick: false,
			menu: [{
                label: 'Project Dashboard',
                icon: 'pi pi-fw pi-folder-open',
                to: '/project'
            },
                {
                    label: 'Sample Status',
                    icon: 'pi pi-fw pi-tags',
                    to: '/SampleStatus'
                },
                // {
                //     label: 'Contact PM',
                //     icon: 'pi pi-fw pi-envelope',
                //     to: '/Contact'
                // }
            ] // 路由菜单信息
		}
	},
	watch: {
		$route() {
			this.menuActive = false;
			this.$toast.removeAllGroups();
			var mainstyle = document.getElementById("mainstyle");
			var alertstyle = document.getElementById("alertstyle");
			var rdReportstyle = document.getElementById("rdReportstyle");
			if (location.href.includes("samplelibrary/Storage/sampleStorageList")) {
				mainstyle.innerHTML = `
				.p-tieredmenu {
					max-height:260px !important;
					overflow-y:auto !important;
				}
				.p-toast {
					z-index: 9998 !important
				}
				.p-dialog-mask{
					z-index: 9999 !important
				}		
				`
			} else {
				mainstyle.innerHTML = `
				.p-tieredmenu
				{
				max-height:260px !important;
				overflow-y:auto !important;
				}
				`
			}
			if (location.href.includes("experimentTemplate/experimentTemplateEdit") || location.href.includes("project/RdReport/RdReportEdit")) {
				alertstyle.innerHTML = `
				.rdReportBanli .p-datatable-emptymessage td {
					width: 100%;
					height: 45px;
				}
				.rdReportBanli .p-datatable-emptymessage td .notMsg{
					margin: 0 auto;
				}
				`
        rdReportstyle.innerHTML = `
				.p-datatable-emptymessage td {
					width: 100%;
					height: 45px;
				}
				.p-datatable-emptymessage td .notMsg{
					margin: 0 auto;
				}
				`
			} else {
				alertstyle.innerHTML = ``
			}

		}
	},
	methods: {
		onDocumentClick() {
			if (!this.searchClick && this.searchActive) {
				this.onSearchHide();
			}

			if (!this.topbarItemClick) {
				this.topbarMenuActive = false;
			}

			if (!this.menuClick) {
				if (this.isHorizontal() || this.isSlim()) {
					this.menuActive = false;
					EventBus.emit('reset-active-index');
				}

				if (this.overlayMenuActive || this.staticMenuMobileActive) {
					this.overlayMenuActive = false;
					this.staticMenuMobileActive = false;
				}

				this.hideOverlayMenu();
				this.unblockBodyScroll();
			}

			if (!this.rightMenuClick) {
				this.rightMenuActive = false;
			}

			if (this.configActive && !this.configClick) {
				this.configActive = false;
			}

			this.topbarItemClick = false;
			this.menuClick = false;
			this.configClick = false;
			this.rightMenuClick = false;
			this.searchClick = false;
			this.inlineMenuClick = false;
		},
		onSearchHide() {
			this.searchActive = false;
			this.searchClick = false;
		},
		onSidebarMouseOver() {
			if (this.menuMode === 'sidebar' && !this.sidebarStatic) {
				this.sidebarActive = this.isDesktop();
				setTimeout(() => {
					this.pinActive = this.isDesktop();
				}, 200);
			}
		},
		onSidebarMouseLeave() {
			if (this.menuMode === 'sidebar' && !this.sidebarStatic) {
				setTimeout(() => {
					this.sidebarActive = false;
					this.pinActive = false;
				}, 250);
			}
		},
		hideOverlayMenu() {
			this.overlayMenuActive = false;
			this.staticMenuMobileActive = false;
		},
		onMenuButtonClick(event) {
			this.menuClick = true;

			if (this.isOverlay()) {
				this.overlayMenuActive = !this.overlayMenuActive;
			}

			if (this.isDesktop()) {
				this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
			} else {
				this.staticMenuMobileActive = !this.staticMenuMobileActive;
			}

			event.preventDefault();
		},
		onTopbarItemClick(event) {
			this.topbarItemClick = true;
			this.topbarMenuActive = !this.topbarMenuActive;
			this.hideOverlayMenu();
			event.preventDefault();
		},
		onRightMenuButtonClick() {
			this.rightMenuClick = true;
			this.rightMenuActive = true;
		},
		onRightMenuClick() {
			this.rightMenuClick = true;
		},
		onMenuClick() {
			this.menuClick = true;
		},
		onRootMenuItemClick() {
			this.menuActive = !this.menuActive;
		},
		onMenuItemClick(event) {
			if (!event.item.items) {
				this.hideOverlayMenu();
				EventBus.emit('reset-active-index');
			}

			if (!event.item.items && (this.isHorizontal() || this.isSlim())) {
				this.menuActive = false;
			}
		},
		onChangeMenuMode(menuMode) {
			console.log(menuMode,'menuMode');
			this.menuMode = menuMode;
			this.overlayMenuActive = false;
		},
		onConfigClick() {
			this.configClick = true;
		},
		onConfigButtonClick(event) {
			this.configActive = !this.configActive;
			this.configClick = true;
			event.preventDefault();
		},
		onChangeRightMenuActive(active) {
			this.rightMenuActive = active;
		},
		onChangeMenuTheme(theme) {
			this.$emit('change-menu-theme', theme);
		},
		onChangeComponentTheme(theme) {
			this.$emit('change-component-theme', theme);
		},
		onChangeColorScheme(scheme) {
			this.$emit('change-color-scheme', scheme);
		},
		onToggleMenu(event) {
			this.menuClick = true;

			if (this.overlayMenuActive) {
				this.overlayMenuActive = false;
			}

			if (this.sidebarActive) {
				this.sidebarStatic = !this.sidebarStatic;
				this.$store.state.sidebarStatic = this.sidebarStatic;
				localStorage.setItem('sidebarStatic', this.sidebarStatic);
			}


			event.preventDefault();
		},
		onChangeActiveInlineMenu() {
			this.activeInlineProfile = !this.activeInlineProfile;
		},
		blockBodyScroll() {
			if (document.body.classList) {
				document.body.classList.add('blocked-scroll');
			} else {
				document.body.className += ' blocked-scroll';
			}
		},
		unblockBodyScroll() {
			if (document.body.classList) {
				document.body.classList.remove('blocked-scroll');
			} else {
				document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
					'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
			}
		},
		isHorizontal() {
			return this.menuMode === 'horizontal';
		},
		isSlim() {
			return this.menuMode === 'slim';
		},
		isOverlay() {
			return this.menuMode === 'overlay';
		},
		isStatic() {
			return this.menuMode === 'static';
		},
		isSidebar() {
			return this.menuMode === 'sidebar';
		},
		isDesktop() {
			return window.innerWidth > 991;
		},
		isMobile() {
			return window.innerWidth <= 991;
		}
	},
	computed: {
		layoutContainerClass() {
			return [
				'layout-wrapper',
				{
					'layout-static': this.menuMode === 'static',
					'layout-overlay': this.menuMode === 'overlay',
					'layout-overlay-active': this.overlayMenuActive,
					'layout-slim': this.menuMode === 'slim',
					'layout-horizontal': this.menuMode === 'horizontal',
					'layout-active': this.menuActive,
					'layout-mobile-active': this.staticMenuMobileActive,
					'layout-sidebar': this.menuMode === 'sidebar',
					'layout-sidebar-static': this.menuMode === 'sidebar' && this.sidebarStatic,
					'layout-static-inactive': this.staticMenuDesktopInactive && this.menuMode === 'static',
					'p-ripple-disabled': this.$primevue.config.ripple === false
				}
			];
		},
	},
	components: {
		AppTopBar,
		AppMenu,
		AppRightMenu,
		AppFooter,
		AppBreadcrumb,
		// LoginInvialid,
		// AppConfig
	},
	created(){
		if(localStorage.getItem("sidebarStatic")){
			this.sidebarStatic = localStorage.getItem("sidebarStatic")=="true"?true:false
		}
		if(this.sidebarStatic){
			this.sidebarActive = this.isDesktop();
			setTimeout(() => {
				this.pinActive = this.isDesktop();
			}, 200);
		}
	},
	mounted() {
		// 更新路由菜单信息
		let arr = JSON.parse(localStorage.getItem("router"))
		if (arr && arr.length > 0) {
			arr.forEach((data) => {
				let lable = data.menuName;
				let attr = []
				// data.treeTMenu.forEach(item=>{
				data.children.forEach(item => {
					attr.push({ label: item.menuName, icon: "pi " + item.icon, to: item.url })
				})
				this.menu.push({ label: lable, items: attr, icon: "pi " + data.icon })
			});
		}
	}
}
</script>
<style>
.p-datatable.p-datatable-gridlines.p-datatable-scrollable .p-datatable-tbody>tr+tr>td,
.p-datatable.p-datatable-gridlines.p-datatable-scrollable .p-datatable-tbody>tr:first-child>td {
	overflow: hidden;
}

.icon-custom {
	background-size: 65%;
	background-repeat: no-repeat;
	background-position: center center;
}
.setClassTh {
	position: sticky;
	top: 0;
	/* z-index: 1; */
}
</style>
